import ReactGA from 'react-ga';
import config from '../config.out.json';

const enabled = config.ga.enabled;
const regex = /(\/)?(search|companies|people|company|person|login|register|confirm|my-account|set-new-password|edit-logo|about|bookmarking|privacy|t-and-c|folders|folder|report)?(\/)?(.*)/i  // /i means ignore case when matching

if (enabled) {
  ReactGA.initialize(config.ga.code);
}

export function logPageView() {
  if (enabled) {
    ReactGA.set({ page: window.location.pathname + window.location.search });
    ReactGA.pageview(window.location.pathname + window.location.search);
  }
}

export function logModalView(modal) {
  if (enabled) {
    ReactGA.modalview(modal);
  }
}

export function setUser(id) {
  if (enabled) {
    ReactGA.set({ userId: id });
  }
}

export function logEvent(location) {
  // console.log("path: " + location.pathname)
  // console.log("regex path: " + location.pathname.replace(regex, "$2")) 

  if (enabled) {
    ReactGA.event({
      category: 'companies-house',
      action: location.pathname.replace(regex, "$2") // send second value (page) from regex to GA
    })
  }
}
